import { ConversionList } from "./ConversionList";

/**
 * Convert Imperial Userinput into Metric and do nothing if there is no need to convert
 * Picks the first valid pair from the ConversionList if not specified otherwise
 * @param {Number} value value that gets converted
 * @param {AllUnits} from Type that gets converted From
 * @param {AllUnits} to Type that gets converted Into
 * @returns a Imperial or Metric Number depending on what should be displayed
 */
function ConvertMeasurement({ userInput, from, to }) {
  let value = Number(userInput);
  if (from === to) return value;
  if (isNaN(Number(value))) {
    return value;
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/isNaN#confusing_special-case_behavior
    throw new Error(`Input is not a Number: ${userInput}`);
  }

  let validPair = undefined;
  if (to !== undefined) {
    validPair = ConversionList.find((item) => item.from === from && item.to === to);
  } else {
    validPair = ConversionList.find((item) => item.from === from);
  }

  if (validPair === undefined) {
    throw new Error(`No Conversion available, with ${from.type.name} into ${to.type.name}`);
  }

  let result = validPair.convert(value);

  // INF before is still INF
  if (Number(value) === Number.MAX_SAFE_INTEGER) {
    return (result = Number.MAX_SAFE_INTEGER);
  }

  // fix floating point number precision and convert
  let rounded = Number(result.toPrecision(15));
  return rounded;
}

export default ConvertMeasurement;
